import React from "react";
import SbEditable from "storyblok-react";
import RichText from "src/utils/RichText";
import Button from "src/components/Button";
import Heading from "src/components/Heading";

const CtaSimpleJustified = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="bg-red">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-24 lg:px-8 lg:flex lg:items-center lg:justify-between">
          <div>
            <Heading size="h2" className="block darkgreyBold text-white">
              <RichText>{blok.title}</RichText>
            </Heading>
            <div className="relative before:absolute before:top-0 before:left-0 before:block before:w-px before:h-full before:bg-white mt-5 max-w-2xl">
              <span className="pl-3 text-white text-sm block">
                <RichText>{blok.content}</RichText>
              </span>
            </div>
          </div>
          <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0">
            <div className="inline-flex rounded-md shadow mt-4">
              <Button
                className="bg-white hover:bg-lightgrey !text-darkgrey uppercase"
                target={blok.button_target.cached_url}
              >
                {blok.button_label}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default CtaSimpleJustified;
